<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('general.informationGeneral')}}</p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-6">
          <div class="columns is-multiline">
            <b-field
              :label="$t('detailBonExpedition.dateExpedition')"
              custom-class="has-text-weight-normal is-italic is-marginless"
              class="column is-6 is-marginless">
              <span class="has-text-weight-bold">
                {{ func.formatDate(bonExpedition.dateBonExpedition) }}
              </span>
            </b-field>
            <b-field
              :label="$t('detailBonExpedition.nomDestination')"
              custom-class="has-text-weight-normal is-italic is-marginless"
              class="column is-6 is-marginless">
              <span class="has-text-weight-bold">
                {{ nomDestinataire }}
              </span>
            </b-field>
            <b-field
              :label="$t('detailBonExpedition.nombreElementColis')"
              custom-class="has-text-weight-normal is-italic is-marginless"
              class="column is-6 is-marginless">
              <span class="has-text-weight-bold">
                {{ bonExpedition.nombreElementColis }}
              </span>
            </b-field>
            <b-field
              :label="$t('detailBonExpedition.poidsParColis')"
              custom-class="has-text-weight-normal is-italic is-marginless"
              class="column is-6 is-marginless">
              <span class="has-text-weight-bold">
                {{ bonExpedition.poidsParColis }}
              </span>
            </b-field>
          </div>
        </div>
        <div class="column is-4 has-text-weight-bold">
          <p class="has-text-weight-normal is-italic is-size-6 mgb-10px">
            {{ $t('detailBonExpedition.adresseExpedition') }}
          </p>
          <adresse-detail
            :adresse="bonExpedition.adresseExpedition"
            class="mgl-1">
          </adresse-detail>
        </div>
        <div class="column is-2 has-text-weight-bold">
          <p class="has-text-weight-normal is-italic is-size-6 mgb-0">
            {{ $t('detailBonExpedition.lienTracking') }}
          </p>
          <a
            :href="bonExpedition.lienTracking"
            class="mgl-1 lien"
            target="_blank">
            {{ extractListeNumerosLT }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adresseDetail from '@/components/general/adresseDetail';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'informationsGenerales',
  props: {
    bonExpedition: {
      type: Object,
      required: true,
    },
  },
  components: {
    adresseDetail,
  },
  data() {
    return {
      func: {
        formatDate,
      },
    };
  },
  computed: {
    nomDestinataire() {
      return [
        this.bonExpedition.prenomContactDestinataire,
        this.bonExpedition.nomContactDestinataire,
      ].filter(Boolean).join(' ');
    },
    extractListeNumerosLT() {
      const parsedUrl = new URL(this.bonExpedition.lienTracking);
      const params = new URLSearchParams(parsedUrl.search);
      return params.get('listeNumerosLT');
    },
  },
};
</script>
